import { BackButton } from "../../_ui"
import labels from '../../../_translations/legals.json';
import store from "../../../_services/store";
import legalsText from "../../../legalstext";
import { Container } from "./components";


const LegalNotice = () => {

  return(
    <div className="fadeIn">
      <BackButton title={labels[store.currentLanguage].labels.title} />
      <Container>
        <p style={{whiteSpace: "pre-line"}}>{legalsText[store.currentLanguage] || legalsText["en"]}</p>
      </Container>
      
    </div>
  )
}

export default LegalNotice;